<div class="m-2">&nbsp;</div>
<div class="jumbotron mx-auto">

  <form (ngSubmit)="onSubmit()"
        [formGroup]="changePasswordForm"
        class="container bg-white">
    <h4>Change Account Password</h4>
    <div class="m-2">&nbsp;</div>
    <div class="form-group">

      <div *ngIf="!oldPassword.valid && newPassword.valid && confirmPassword.valid"
           class="alert alert-danger default-size">
        <a class="close"
           data-dismiss="alert"
           aria-hidden="true">
          &times;
        </a>
        * Please, enter your Current Password
      </div>
      <div *ngIf="!passwordMatch()"
           class="alert alert-danger default-size">
        <a class="close"
           data-dismiss="alert"
           aria-hidden="true">
          &times;
        </a>
        * New passwords does not match.
      </div>

      <div class="alert alert-danger"
           *ngIf="errorMessage && passwordMatch()">
        <a type="button"
           class="close"
           data-dismiss="alert"
           aria-hidden="true">&times;</a>
        <strong>Error!</strong> {{errorMessage}}
      </div>

      <div class="alert alert-success"
           *ngIf="successMessage">
        <a class="close"
           data-dismiss="alert"
           aria-hidden="true">
          &times;
        </a>
        {{ successMessage }}
      </div>
    </div>
    <div class="form-group">
      <input type="password"
             class="form-control"
             formControlName="oldPassword"
             id="oldPassword"
             aria-describedby="oldPassword"
             placeholder="Enter Current Password." />
    </div>
    <div class="form-group">
      <input type="password"
             class="form-control"
             formControlName="newPassword"
             id="newPassword"
             aria-describedby="newPassword"
             placeholder="Enter new Password"
             pattern="^(?=\S*[a-zA-Z])(?=\S*[0-9])(?=\S*\d)\S{8,}$" />
      <div *ngIf="oldPassword.touched&&oldPassword.errors"
           class="error_message">
        Password should be at least 8 characters long, containing at least one
        number and one letter.
      </div>
    </div>
    <div class="form-group">
      <input type="password"
             formControlName="confirmPassword"
             class="form-control"
             id="confirmPassword"
             aria-describedby="confirmPassword"
             placeholder="Confirm Password"
             pattern="^(?=\S*[a-zA-Z])(?=\S*[0-9])(?=\S*\d)\S{8,}$" />
    </div>

    <button type="submit"
            class="btn btn-primary"
            [disabled]="!changePasswordForm.valid || !passwordMatch() || loading">
      <span class="spinner-border"
            *ngIf="loading"
            role="status"
            aria-hidden="true"></span>

      <span *ngIf="!loading">Change Password</span>
    </button>

    <a routerLink=".."
       class="btn btn-danger btn-secondary text-white button">
      Cancel
    </a>
  </form>
</div>
